/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReactionDto } from './GetReactionDto';
import {
    GetReactionDtoFromJSON,
    GetReactionDtoFromJSONTyped,
    GetReactionDtoToJSON,
} from './GetReactionDto';

/**
 * 
 * @export
 * @interface GetResultForTestsDto
 */
export interface GetResultForTestsDto {
    /**
     * 
     * @type {string}
     * @memberof GetResultForTestsDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetResultForTestsDto
     */
    taskTime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetResultForTestsDto
     */
    taskText?: string | null;
    /**
     * 
     * @type {Array<GetReactionDto>}
     * @memberof GetResultForTestsDto
     */
    reactions: Array<GetReactionDto>;
}

/**
 * Check if a given object implements the GetResultForTestsDto interface.
 */
export function instanceOfGetResultForTestsDto(value: object): value is GetResultForTestsDto {
    if (!('reactions' in value) || value['reactions'] === undefined) return false;
    return true;
}

export function GetResultForTestsDtoFromJSON(json: any): GetResultForTestsDto {
    return GetResultForTestsDtoFromJSONTyped(json, false);
}

export function GetResultForTestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetResultForTestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'taskTime': json['taskTime'] == null ? undefined : json['taskTime'],
        'taskText': json['taskText'] == null ? undefined : json['taskText'],
        'reactions': ((json['reactions'] as Array<any>).map(GetReactionDtoFromJSON)),
    };
}

export function GetResultForTestsDtoToJSON(value?: GetResultForTestsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'taskNumber': value['taskNumber'],
        'taskTime': value['taskTime'],
        'taskText': value['taskText'],
        'reactions': ((value['reactions'] as Array<any>).map(GetReactionDtoToJSON)),
    };
}

